import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Convert a local image URL from .png/.jpg to .webp for smaller file sizes.
 * Only converts paths under /images/ (local static assets).
 * External URLs and already-.webp paths are returned unchanged.
 */
export function toWebpUrl(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  if (!url.startsWith("/images/")) return url;
  if (url.endsWith(".webp")) return url;
  return url.replace(/\.(png|jpe?g)$/i, ".webp");
}

/** Default WebP fallback used when a blog post has no image and no category match. */
export const BLOG_FALLBACK_CREATIVE = "/images/blog/blog-creative.webp";

/** Category-to-fallback map for blog post images. */
export const blogFallbackImages: Record<string, string> = {
  "Case Study": BLOG_FALLBACK_CREATIVE,
  "Guide": "/images/blog/blog-seo.webp",
  "Analysis": "/images/blog/blog-attribution.webp",
  "Trend": BLOG_FALLBACK_CREATIVE,
  "Strategy": "/images/blog/blog-seo.webp",
  "Ecommerce": "/images/blog/blog-attribution.webp",
};
